import { Navigate, Route, Routes } from "react-router-dom";
import { FaqView } from "../faq-view";

export function FaqShell() {
  return (
    <Routes>
      <Route path="/" element={<FaqView />} />
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
}

export default FaqShell;
